import React from "react";

import "./groupUsers.scss";

import { type EnrollmentRule } from "features/People/Groups/AddEditGroupForms/EnrollmentBuilder/utils";
import { type GetGroupEnrollmentUsersPreviewRequest, type GroupUsersState, type UserInfo } from "features/People/types";
import { type FiltersMap } from "utils/filterUtils";
import { ValidatedForm } from "../../../../../components/forms";
import validationSchemas from "../../../../../utils/validationSchemas";
import AutomaticallyDetect from "../../AddEditGroupForms/AutomaticallyDetect/AutomaticallyDetect";
import ManageMembers from "./ManageMembers/ManageMembers";

type UserOptions = {
  items: UserInfo[];
  itemsCount: number;
  isLoading: boolean;
  appliedFilter?: FiltersMap;
};

type Props = {
  groupId: number;
  addMembersBtn: React.ReactNode;
  groupUsers: {
    enrollmentRules: EnrollmentRule[];
  };
  enrollmentUsersOptions: UserOptions;
  loadEnrollmentUsers: (
    skip: number,
    top: number,
    orderByParams: string,
    filterParams: FiltersMap,
  ) => (dispatch: Function) => Promise<void>;
  resetEnrollmentUsers: () => void;
  setAutomaticEnrollmentGridFilter: () => void;
  isWithAutoEnroll: boolean;
  bindSubmitForm: (submitForm: () => void) => void;
  onSubmit: (groupUsers: GroupUsersState) => Promise<void>;
  onIsValidChange?: (isValid: boolean) => void;
  isInitialValid?: boolean;
  fetchGroupEnrollmentUsers: (req: GetGroupEnrollmentUsersPreviewRequest) => void;
  groupEnrollmentUsers: UserOptions;
  bindGetDraftEnrollmentRulesValues: (getDraftEnrollmentRules: () => GroupUsersState) => void;
};

const GroupUsers = ({
  groupId,
  addMembersBtn,
  groupUsers,
  isWithAutoEnroll,
  onSubmit,
  bindSubmitForm,
  isInitialValid,
  bindGetDraftEnrollmentRulesValues,
  onIsValidChange,
  groupEnrollmentUsers,
  enrollmentUsersOptions,
  loadEnrollmentUsers,
  setAutomaticEnrollmentGridFilter,
  fetchGroupEnrollmentUsers,
  resetEnrollmentUsers,
}: Props) => {
  return (
    <section className="group-users">
      <div className="stretch">
        {isWithAutoEnroll ? (
          <ValidatedForm
            onSubmit={onSubmit}
            bindGetValues={bindGetDraftEnrollmentRulesValues}
            bindSubmitForm={bindSubmitForm}
            isInitialValid={isInitialValid}
            initialValues={groupUsers}
            validationSchema={validationSchemas.automaticEnrollment}
            unsavedChangesPrompt={{
              title: "Exit Without Saving?",
              message: "Are you sure you want to exit without saving this group? All information entered will be lost.",
            }}
            formWidthComputer={16}
          >
            {
              /* instanbul ignore next */
              (formProps) => {
                const { values, validatedFieldProps } = formProps;

                return (
                  <AutomaticallyDetect
                    onIsValidChange={onIsValidChange}
                    values={values}
                    validatedFieldProps={validatedFieldProps}
                    users={groupEnrollmentUsers.items}
                    usersCount={groupEnrollmentUsers.itemsCount}
                    isLoading={groupEnrollmentUsers.isLoading}
                    loadUsers={loadEnrollmentUsers}
                    gridFilter={enrollmentUsersOptions.appliedFilter || {}}
                    setGridFilter={setAutomaticEnrollmentGridFilter}
                    resetEnrollmentUsers={resetEnrollmentUsers}
                    fetchGroupEnrollmentUsers={fetchGroupEnrollmentUsers}
                  />
                );
              }
            }
          </ValidatedForm>
        ) : (
          <ManageMembers groupId={groupId} addMembersBtn={addMembersBtn} />
        )}
      </div>
    </section>
  );
};

export default GroupUsers;
